export function getProjectNameHeader(projectName) {
    return {
        headers: {
            'Project-Name': projectName
        }
    };
}
